import { http } from "../httpHandler";
import {
  TServerErrorResponse,
  PdfTemplateEntity,
  PdfTemplateFillRequest,
  ExcelTemplateEntity,
  ExcelFillRequest,
} from "@/types";
import { links } from "@/constants";

export const GET_ALL_PDF_TEMPLATES = "GET_ALL_PDF_TEMPLATES";
export const GET_PDF_TEMPLATE_BY_ID = "GET_PDF_TEMPLATE_BY_ID";
export const GET_ALL_EXCEL_TEMPLATES = "GET_ALL_EXCEL_TEMPLATES";
export const GET_EXCEL_TEMPLATE_BY_ID = "GET_EXCEL_TEMPLATE_BY_ID";

/**
 * Get all PDF templates
 */
export const getAllPdfTemplates = async (): Promise<PdfTemplateEntity[]> => {
  try {
    const response = await http.get<PdfTemplateEntity[]>(
      links.document.index,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/**
 * Get a specific PDF template by ID
 */
export const getPdfTemplateById = async (
  templateId: string,
): Promise<PdfTemplateEntity> => {
  try {
    const response = await http.get<PdfTemplateEntity>(
      links.document.pdfById(templateId),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/**
 * Fill a PDF template with data
 */
export const fillPdfTemplate = async (
  templateId: string,
  data: PdfTemplateFillRequest,
): Promise<Blob> => {
  try {
    const response = await http.post<Blob>(
      links.document.fillPdf(templateId),
      data,
      {
        responseType: "blob",
        headers: {
          accept: "application/pdf, application/octet-stream, */*",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/**
 * Get all Excel templates
 */
export const getAllExcelTemplates = async (): Promise<ExcelTemplateEntity[]> => {
  try {
    const response = await http.get<ExcelTemplateEntity[]>(
      links.document.excel,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/**
 * Get a specific Excel template by ID
 */
export const getExcelTemplateById = async (
  templateId: string,
): Promise<ExcelTemplateEntity> => {
  try {
    const response = await http.get<ExcelTemplateEntity>(
      links.document.excelById(templateId),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/**
 * Fill an Excel template with data and download
 */
export const fillExcelTemplate = async (
  templateId: string,
  data: ExcelFillRequest,
): Promise<Blob> => {
  try {
    const response = await http.post<Blob>(
      links.document.fillExcel(templateId),
      data,
      {
        responseType: "blob",
        headers: {
          accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream, */*",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
